import { c as _c } from "react/compiler-runtime";
import type { LpCardListItem } from '@cc-shopping/contracts/credit-cards-page/landing-page/CreditCardsLPCardList';
import { FlipCard } from '@cc-shopping/ui/composites/FlipCard';
import { Box, Link, Typography } from '@mui/material';
import { noteAnchorId, noteMarker } from '../notes';
import { BackSide } from './BackSide';
type Props = {
  anchorPrefix: string;
  item: LpCardListItem;
};
export function Card(t0) {
  const $ = _c(24);
  const {
    anchorPrefix,
    item
  } = t0;
  const {
    children,
    imageAltText,
    imageUrl,
    noteRefs,
    title
  } = item;
  let t1;
  if ($[0] !== anchorPrefix || $[1] !== noteRefs) {
    let t2;
    if ($[3] !== anchorPrefix) {
      t2 = position => <Link key={position} href={`#${noteAnchorId(anchorPrefix, position)}`} rel="noopener noreferrer" color="inherit" aria-label={`See footnote ${position}`}>{noteMarker(position)}</Link>;
      $[3] = anchorPrefix;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = noteRefs.map(t2);
    $[0] = anchorPrefix;
    $[1] = noteRefs;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const linkNodes = t1;
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      sx: {
        minHeight: "250px"
      }
    };
    t3 = {
      sx: {
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        gap: 3,
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "1.5rem",
        boxSizing: "border-box",
        height: "100%"
      }
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== imageAltText || $[8] !== imageUrl || $[9] !== title) {
    t4 = imageUrl && <Box component="img" src={imageUrl} alt={imageAltText || title} sx={{
      width: 80,
      height: 80,
      objectFit: "contain"
    }} />;
    $[7] = imageAltText;
    $[8] = imageUrl;
    $[9] = title;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontSize: 18,
      fontWeight: 500
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== title) {
    t6 = <Typography component="h3" sx={t5}>{title}</Typography>;
    $[12] = title;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== children || $[18] !== linkNodes) {
    t8 = <BackSide key="back-side" description={children} linkNodes={linkNodes} />;
    $[17] = children;
    $[18] = linkNodes;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span key="flip-icon" aria-hidden="true" className="mask-icon mask-icon-loop" style={{
      display: "flex",
      position: "absolute",
      top: "16px",
      right: "16px",
      width: "30px",
      height: "30px",
      backgroundColor: "#42A5F5"
    }} />;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t8) {
    t10 = <FlipCard boxProps={t2} cardProps={t3} frontNode={t7} backNode={t8} shouldRotateOnlyOnDesktop={true} customFlipIcon={t9} />;
    $[21] = t7;
    $[22] = t8;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}